import { MenuTipPercentageSettingsBuilder } from "./menu.percentage.builder";

export class MenuTipPercentageSettings {
  public readonly minimum: number;
  public readonly one: number;
  public readonly two: number;
  public readonly three: number;
  constructor(builder: MenuTipPercentageSettingsBuilder) {
    this.minimum = builder.minimum;
    this.one = builder.one;
    this.two = builder.two;
    this.three = builder.three;
  }
}
